import React, { useState } from 'react'
import GithubIcon from "@material-ui/icons/GitHub";
import { Link } from "react-router-dom"

const Navbar = () => {
  // Check If The Menu Is Open And Close Him When The User Click Him Again
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-gradient-to-r from-amber-100 to-amber-400 border-gray-200 dark:text-white">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 ">
            <a href="https://github.com/MosheBens" className="flex items-center space-x-3 rtl:space-x-reverse" target="_blank" rel="noreferrer">
                <GithubIcon className='text-black hover:text-slate-600' style={{ fontSize: 50 }}/>
                <span className="self-center text-2xl font-semibold whitespace-nowrap ">My Github</span>
            </a>
            <button onClick={toggleMenu} data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-12 h-12 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 " aria-controls="navbar-default" aria-expanded="false">
                <span className="sr-only">Open main menu</span>
                <svg className="w-10 h-10 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
                </svg>
            </button>
            <div className={`w-full md:block  md:w-auto ${isMenuOpen ? 'block' : 'hidden'}`} id="navbar-default">
            {/* <ul className={`font-medium flex flex-col ${isMenuOpen ? "divide-y-4 divide-yellow-100" : ""} p-4 md:p-0 mt-4 border border-red-400  rounded-lg  md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 `}> */}
            <ul className={`font-medium flex flex-col ${isMenuOpen ? "divide-y-4 divide-amber-400" : ""} p-4 md:p-0 mt-4 border border-red-400  rounded-lg  md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 dark:text-white `}>
                <li>
                <Link to={"/"}  onClick= {isMenuOpen ? toggleMenu : ""} className="block text-2xl py-2 px-3 text-gray-900 hover:bg-gray-200 hover:text-blue-500 rounded md:bg-transparent  md:p-0" aria-current="page">Home</Link>
                </li>
                <li>
                <Link to={"/projects"} className="block  text-2xl py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0" onClick= {isMenuOpen ? toggleMenu : ""}>Projects</Link>
                </li>
                <li>
                <Link to={"/aboutme"}  className="block text-2xl py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0" onClick= {isMenuOpen ? toggleMenu : ""}>About</Link>
                </li>
                {/* <li>
                <Link to={"/contact"} className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent" onClick={() => {toggleMenu()}}>Contact</Link>
                </li> */}
                {/* <li>
                <a href="/" className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</a>
                </li> */}
            </ul>
            </div>
        </div>
    </nav>
  )
}

export default Navbar